import {
  RESET_PAGINATION,
  UPDATE_PAGE_COUNT,
  UPDATE_PAGE_NUM,
  UPDATE_PAGE_SIZE,
} from './mutation-types'

export default {
  namespaced: true,
  state: {
    pageCount: 0,
    pageSize: 50,
    pageNum: 1,
    pageSizes: [50, 100, 200, 500, 800],
  },
  mutations: {
    [UPDATE_PAGE_COUNT](state, payload) {
      state.pageCount = payload
    },
    [UPDATE_PAGE_NUM](state, payload) {
      state.pageNum = payload
    },
    [UPDATE_PAGE_SIZE](state, payload) {
      state.pageSize = payload
    },
    [RESET_PAGINATION](state) {
      state.pageSize = 50
      state.pageNum = 1
      state.pageCount = 0
    },
  },
  actions: {
    resetPagination({ commit }) {
      commit(RESET_PAGINATION)
    },
    updatePageCount({ commit }, payload) {
      commit(UPDATE_PAGE_COUNT, payload)
    },
    updatePageNum({ commit }, payload) {
      commit(UPDATE_PAGE_NUM, payload)
    },
    updatePageSize({ commit }, payload) {
      commit(UPDATE_PAGE_SIZE, payload)
    },
  },
}
